import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  withRouter,
} from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import GeneralBloc from "../../../bloc/general_bloc";
import AppMainButton from "../../component/app_main_button/app_main_button";
import AppTransparentButton from "../../component/app_transparent_button/app_transparent_button";
import "./app_notice_dialog.css";
import AppTextField from "../../component/form/app_text_field/app_text_field";
import AppTextAreaField from "../../component/form/app_text_field/app_textarea_field";
import AppTextFieldConfig from "../../component/form/app_text_field/app_text_field_config";
import AppFieldContainer from "../../component/form/app_field_container/app_field_container";
import LanguageBloc from "../../../bloc/language_bloc";
import Labels from "../../constant/labels";
import { Input } from 'antd';
import AppFieldError from "../../component/form/app_field_error/app_field_error";
const { TextArea } = Input;

class AppDeleteSignatureDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      additionalEmail: "",
      comment: "",
      refs: {
        additionalEmail: React.createRef(),
        comment: React.createRef(),
      }
    }
  }

  propTitle() {
    return this.props.title;
  }
  propSubTitle() {
    return this.props.subTitle;
  }
  propPositiveButton() {
    return this.props.positiveButton;
  }
  propNegativeButton() {
    return this.props.negativeButton;
  }

  propShowClose() {
    return this.props.showClose || false;
  }

  onValidateReject() {
    return this.state.comment.length > 0;
  }

  stateFilterFieldsList() {
    return this.state.filterFieldsList || []
  }

  componentDidMount() {

  }


  comment() {
    let id = "comment"
    return <div>
      <div style={{ fontSize: "16px", marginBottom: "5px" }}>
        <span style={{ color: "rgb(218, 41, 28)" }}>{
          this.props.compulsory ? "*" : ""
        }</span> Comment
      </div>
      <TextArea
        disabled={false}
        showCount
        rows={5}
        maxLength={200}
        style={{ marginBottom: "14px", borderRadius: 16, fontSize: "16px", resize: 'none' }}
        onChange={(e) => {
          let value = e.target.value;
          let errorcomment = "";

          if (!value && this.props.compulsory) {
            errorcomment = `Please enter deleted comments`;
          }

          if (value && this.props.compulsory && value.charAt(0) === " ") {
            errorcomment = `Please enter deleted comments`;
          }

          this.setState({
            comment: value,
            errorcomment
          })
          if (this.props.getContent) {
            // this.props.getContent(value);
          }
        }}
        value={this.state.comment}
        placeholder={`Write down your comments here...`}
      />
      <AppFieldError
        text={LanguageBloc.getTextByCode(
          this.state.errorcomment
        )}
      />
    </div>

  }

  render() {
    return (
      <Modal
        backdrop="static"
        centered
        style={{ maxWidth: "480px" }}
        isOpen={this.props.isOpen}
      >
        <ModalBody>
          {this.propShowClose() == true && (
            <div style={{ "text-align": "right", marginBottom: "-50px" }}>
              <div>
                <img
                  src={
                    GeneralBloc.getAssetsContextPath() +
                    "/assets/images/Clear_Icon.svg"
                  }
                  className="terms_and_condition_close_button"
                  onClick={() => this.props.onCloseDialog("no")}
                />
              </div>
            </div>
          )}
          <div className="row no-gutters notice_modal_content">
            <div className="col-md-12 text-left">
              <nobr><div className="notice_dialog_title"
                dangerouslySetInnerHTML={{
                  __html: this.propTitle()
                }}
              ></div></nobr>
              <div className="notice_dialog_desc mt-2"
                dangerouslySetInnerHTML={{
                  __html: this.propSubTitle()
                }}
              >
              </div>

              <div className="button_container">
                <div style={{ marginTop: "0px", width: "412px" }}>
                  {
                    this.state.filterFieldsList && this.state.filterFieldsList.length > 0 && this.filterFieldsDropDown()
                  }
                  {
                    this.comment()
                  }
                </div>
                {this.propPositiveButton() ? (
                  <>
                    <AppMainButton
                      //   label={this.props.lableNext}
                      label={this.propPositiveButton()}
                      enable={this.props.compulsory ? this.onValidateReject() : true}
                      //   enable={this.props.enable}
                      onClick={() => this.props.onCloseDialog("yes",this.state.comment)}
                      icon={false}
                      buttonWidth={this.props.positiveButtonWidth || "385px"}
                    />
                  </>
                ) : null}
                {this.propNegativeButton() ? (
                  <>
                    <AppTransparentButton
                      //   label={this.props.lableSaveAndClose}
                      label={this.propNegativeButton()}
                      enable={this.props.enable}
                      onClick={() => this.props.onCloseDialog("no")}
                      buttonWidth={this.props.negativeButtonWidth || "385px"}
                    />
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
export default withRouter(AppDeleteSignatureDialog);
